import React, { useState } from 'react';
import { BookOpen, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id) => {
    if (!isHomePage) {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    setIsMenuOpen(false);
  };

  const handleAuthorClick = () => {
    navigate('/author');
    setIsMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-lg">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <button onClick={handleLogoClick} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center shadow-lg transform hover:scale-110 transition-transform duration-300">
              <BookOpen className="h-7 w-7 text-white" />
            </div>
            <div>
              <span className="text-xl font-black text-gray-900 block">Word Search</span>
              <p className="text-xs text-orange-600 font-semibold">Puzzle Books</p>
            </div>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('books-section')}
              className="text-gray-700 hover:text-orange-500 font-semibold transition-colors duration-200"
            >
              Books
            </button>
            <button
              onClick={handleAuthorClick}
              className="text-gray-700 hover:text-orange-500 font-semibold transition-colors duration-200"
            >
              Author
            </button>
            <button
              onClick={() => scrollToSection('newsletter')}
              className="text-gray-700 hover:text-orange-500 font-semibold transition-colors duration-200"
            >
              Newsletter
            </button>
            <Button
              onClick={() => scrollToSection('books-section')}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 shadow-lg transition-all duration-300 hover:shadow-xl"
            >
              Shop Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-gray-900" />
            ) : (
              <Menu className="h-6 w-6 text-gray-900" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('books-section')}
                className="text-left text-gray-700 hover:text-orange-500 font-semibold py-2 transition-colors duration-200"
              >
                Books
              </button>
              <button
                onClick={handleAuthorClick}
                className="text-left text-gray-700 hover:text-orange-500 font-semibold py-2 transition-colors duration-200"
              >
                Author
              </button>
              <button
                onClick={() => scrollToSection('newsletter')}
                className="text-left text-gray-700 hover:text-orange-500 font-semibold py-2 transition-colors duration-200"
              >
                Newsletter
              </button>
              <Button
                onClick={() => scrollToSection('books-section')}
                className="bg-orange-500 hover:bg-orange-600 text-white font-bold shadow-lg"
              >
                Shop Now
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
